const InfoIcon = ({
  fill = "#02636F",
  size = 20,
}: {
  fill?: string;
  size?: number;
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        d="M9.99619 13.8565C10.1798 13.8565 10.3326 13.7962 10.4547 13.6756C10.5768 13.555 10.6378 13.4029 10.6378 13.2193C10.6378 13.0357 10.5775 12.8829 10.4569 12.7608C10.3363 12.6387 10.1842 12.5777 10.0006 12.5777C9.81695 12.5777 9.66412 12.638 9.54206 12.7586C9.41999 12.8792 9.35896 13.0313 9.35896 13.2149C9.35896 13.3985 9.41926 13.5514 9.53985 13.6734C9.66045 13.7955 9.81256 13.8565 9.99619 13.8565ZM10.0071 10.8958C10.1674 10.8958 10.3046 10.8387 10.4186 10.7245C10.5327 10.6104 10.5897 10.4725 10.5897 10.3109V6.54404C10.5897 6.38553 10.5325 6.24908 10.4181 6.13469C10.3036 6.02031 10.1671 5.96312 10.0085 5.96312C9.84684 5.96312 9.70898 6.02031 9.59494 6.13469C9.4809 6.24908 9.42388 6.38553 9.42388 6.54404V10.3109C9.42388 10.4725 9.48099 10.6104 9.59523 10.7245C9.70945 10.8387 9.84673 10.8958 10.0071 10.8958ZM10.0003 17.7467C8.92874 17.7467 7.92133 17.5431 6.97808 17.1358C6.03483 16.7285 5.21433 16.1758 4.51658 15.4776C3.81883 14.7794 3.26663 13.9596 2.85998 13.0181C2.45333 12.0766 2.25 11.0707 2.25 10.0003C2.25 8.92874 2.45365 7.92133 2.86094 6.97808C3.26822 6.03483 3.82096 5.21433 4.51917 4.51658C5.21736 3.81883 6.03719 3.26663 6.97865 2.85998C7.9201 2.45333 8.92604 2.25 9.99646 2.25C11.068 2.25 12.0754 2.45365 13.0187 2.86094C13.9619 3.26822 14.7824 3.82096 15.4802 4.51917C16.1779 5.21736 16.7301 6.03719 17.1368 6.97865C17.5434 7.9201 17.7467 8.92604 17.7467 9.99646C17.7467 11.068 17.5431 12.0754 17.1358 13.0187C16.7285 13.9619 16.1758 14.7824 15.4776 15.4802C14.7794 16.1779 13.9596 16.7301 13.0181 17.1368C12.0766 17.5434 11.0707 17.7467 10.0003 17.7467Z"
        fill={fill}
      />
    </svg>
  );
};

export default InfoIcon;
